export const profileText = {
  tiny: 'かなりの小柄で',
  small: '小柄で',
  averageHeight: 'ほどよい背の高さに',
  tall: '長身で',
  veryTall: 'かなりの長身で',
  flatTits: 'なだらかな胸',
  smallTits: '控えめな胸',
  averageTits: '形の整った胸',
  bigTits: '大きく膨らんだ胸',
  hugeTits: 'こぼれそうなほど豊かな胸',
  skinnyWeist: '華奢な腰つき',
  slimWeist: 'ほっそりとした腰つき',
  averageWeist: 'くびれた腰つき',
  curvyWeist: 'むっちりとした腰つき',
  chubbyWeist: 'とてもふくよかな腰つき',
  flatButt: 'すらりとしたお尻',
  smallButt: '小ぶりなお尻',
  averageHip: 'きゅっと引き締まったお尻',
  bigButt: '大きめなお尻',
  hugeButt: 'はちきれんばかりに大きなお尻',
}
